import React from "react";
import { Card, CardContainer } from "../../../components/Card";
import { Typography, Box, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FollowersSlider from "../../../components/FollowersSlider";

function Mentions({ data }) {
    const theme = useTheme();

    const cardStyle = {
        border: "1px solid",
        borderColor: theme.palette.secondary[500],
        borderRadius: "50px",
        padding: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        whiteSpace: "nowrap", // Prevent text from wrapping
    };

    const gridStyle = {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", // Adjust columns to fit
        gap: "10px", // Gap between items
    };

    const renderGrid = (items, prefix) => (
        <div style={gridStyle}>
            {items.map((item, index) => (
                <Tooltip key={index} title={`Value: ${item.value}`} arrow>
                    <Box sx={cardStyle}>
                        <Typography variant="body1">
                            {prefix}
                            {item.name}
                        </Typography>
                    </Box>
                </Tooltip>
            ))}
        </div>
    );

    return (
        <CardContainer className="export-section mentions-section">
            <Card>
                <Typography
                    variant="highlightSemibold"
                    component="h2"
                    gutterBottom
                >
                    Top Hashtags
                </Typography>
                {renderGrid(data.top.hashtags, "#")}
            </Card>
            <Card>
                <Typography
                    variant="highlightSemibold"
                    component="h2"
                    gutterBottom
                >
                    Top Mentions
                </Typography>
                {renderGrid(data.top.mentions, "@")}
            </Card>
            <Box className="no-export">
                <FollowersSlider
                    data={data?.audience?.lookalikes}
                    containerTitle="Similar Creators"
                />
            </Box>
        </CardContainer>
    );
}

export default Mentions;
